import { isLockedSkill } from './utils';

export function availableSkillGroups(skills, names) {
    const grouped = {};
    skills.filter(skill => !isLockedSkill(skill)).forEach(skill => {
        (grouped[String(skill.skillset)] ||= []).push(skill);
    });
    Object.values(grouped).forEach(group => group.sort((a, b) => a.name.localeCompare(b.name)));
    const keys = Object.keys(grouped).sort((a, b) =>
        (names[a] || `Skillset ${a}`).localeCompare(names[b] || `Skillset ${b}`));
    return { grouped, keys };
}
